__webpack_require__.p = "https://cdn.jsdelivr.net/npm/vf-widgets@0.2.48/build/";